export default __webpack_public_path__ + "static/media/deutz-fahr-6190-ttv.c85ca9fc.jpg";